var StandardComments = {
	ALL: [
		{ type: "positive", group: "Content", subgroup: "overall", 
			body: "I like that you wrote a very thoughtful and creative answer!" },
		{ type: "negative", group: "Content", subgroup: "overall", 
			body: "Please stay focused on answering the question." },

		{ type: "positive", group: "Content", subgroup: "restatement", 
			body: "I like that you restated the question in your answer!" },
		{ type: "negative", group: "Content", subgroup: "restatement", 
			body: "Please restate the question in your answer." },

		{ type: "positive", group: "Content", subgroup: "all-parts", 
			body: "I like that you answered all parts of the question!" },
		{ type: "negative", group: "Content", subgroup: "all-parts", 
			body: "Please answer all parts of the question." },

		{ type: "positive", group: "Content", subgroup: "text-evidence", 
			body: "I like that you used evidence from the text in your answer!" },
		{ type: "negative", group: "Content", subgroup: "text-evidence", 
			body: "Please use evidence from the text in your answer." },

		{ type: "positive", group: "Content", subgroup: "description", 
			body: "I like that you used description and details in your answer!" },
		{ type: "negative", group: "Content", subgroup: "description", 
			body: "Please use more description and details in your answer." },

		{ type: "positive", group: "Content", subgroup: "organized", 
			body: "I like that you organized your answer well and it is easy to read!" },
		{ type: "negative", group: "Content", subgroup: "organized", 
			body: "Please read your answer after you finish to make sure it is organized and easy to read." },

		{ type: "positive", group: "Mechanics", subgroup: "length", 
			body: "I like how much you wrote!" },
		{ type: "negative", group: "Mechanics", subgroup: "length", 
			body: "Please make sure you are writing enough." },

		{ type: "positive", group: "Mechanics", subgroup: "vocabulary", 
			body: "I like that you used advanced vocabulary!" },
		{ type: "negative", group: "Mechanics", subgroup: "vocabulary", 
			body: "Please use grade-level vocabulary instead of basic vocabulary." },

		{ type: "positive", group: "Mechanics", subgroup: "spelling", 
			body: "I like that you paid attention to spelling!" },
		{ type: "negative", group: "Mechanics", subgroup: "spelling", 
			body: "Please remember to check your spelling." },

		{ type: "positive", group: "Mechanics", subgroup: "grammar", 
			body: "I like that you paid attention to grammar!" },
		{ type: "negative", group: "Mechanics", subgroup: "grammar", 
			body: "Please remember to check your grammar." },

		{ type: "positive", group: "Mechanics", subgroup: "sentences", 
			body: "I like that you wrote in complete sentences!" },
		{ type: "negative", group: "Mechanics", subgroup: "sentences", 
			body: "Please write in complete sentences." },

		{ type: "positive", group: "Mechanics", subgroup: "general-mechanics", 
			body: "I like that you used a good mix of long and short sentences!" },
		{ type: "negative", group: "Mechanics", subgroup: "general-mechanics", 
			body: "Please watch the length and punctuation of your sentences to avoid run-on sentences." },

		{ type: "positive", group: "Mechanics", subgroup: "capitalization", 
			body: "I like that you used capital letters correctly!" },
		{ type: "negative", group: "Mechanics", subgroup: "capitalization", 
			body: "Please remember to use capital letters." },
		{ type: "negative", group: "Mechanics", subgroup: "capitalization", 
			body: "Please do not capitalize words that should not be capitalized." },

		{ type: "positive", group: "Mechanics", subgroup: "punctuation", 
			body: "I like that you used punctuation correctly!" },
		{ type: "negative", group: "Mechanics", subgroup: "punctuation", 
			body: "Please use punctuation marks in the right places." },

		{ type: "positive", group: "Mechanics", subgroup: "commas", 
			body: "I like that you used commas correctly!" },
		{ type: "negative", group: "Mechanics", subgroup: "commas", 
			body: "Please use commas in the right places." },
	]
}

module.exports = StandardComments;





// WEBPACK FOOTER //
// ./modules/lib/academic/StandardComments.js